module.exports = "<div class=\"spinner\">\n  <div class=\"rect1\"></div>\n  <div class=\"rect2\"></div>\n  <div class=\"rect3\"></div>\n  <div class=\"rect4\"></div>\n  <div class=\"rect5\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/loading-spinner/loading-spinner.component.html
// module id = ./src/app/ui/loading-spinner/loading-spinner.component.html
// module chunks = main